module.exports = __webpack_public_path__ + "img/garantia-baner.42a69382.webp";